function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { RTLService } from "../../../devsupport";
import { Button } from "../../button/button.component";
import { Text } from "../../text/text.component";
import { ChevronDown } from "../../shared/chevronDown.component";
import { ChevronLeft } from "../../shared/chevronLeft.component";
import { ChevronRight } from "../../shared/chevronRight.component";
export class CalendarHeader extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderTitleIcon", () => {
      const _this$props$iconStyle = this.props.iconStyle,
            {
        tintColor
      } = _this$props$iconStyle,
            svgStyle = _objectWithoutProperties(_this$props$iconStyle, ["tintColor"]);

      return /*#__PURE__*/React.createElement(ChevronDown, {
        style: [styles.headerButtonIcon, svgStyle],
        fill: tintColor
      });
    });

    _defineProperty(this, "renderLeftIcon", () => {
      const _this$props$iconStyle2 = this.props.iconStyle,
            {
        tintColor
      } = _this$props$iconStyle2,
            svgStyle = _objectWithoutProperties(_this$props$iconStyle2, ["tintColor"]);

      const IconComponent = RTLService.select(ChevronLeft, ChevronRight);
      return /*#__PURE__*/React.createElement(IconComponent, {
        style: [styles.lateralIcon, svgStyle],
        fill: tintColor
      });
    });

    _defineProperty(this, "renderRightIcon", () => {
      const _this$props$iconStyle3 = this.props.iconStyle,
            {
        tintColor
      } = _this$props$iconStyle3,
            svgStyle = _objectWithoutProperties(_this$props$iconStyle3, ["tintColor"]);

      const IconComponent = RTLService.select(ChevronRight, ChevronLeft);
      return /*#__PURE__*/React.createElement(IconComponent, {
        style: [styles.lateralIcon, svgStyle],
        fill: tintColor
      });
    });

    _defineProperty(this, "renderLateralNavigationControls", () => {
      return /*#__PURE__*/React.createElement(View, {
        style: styles.subContainer
      }, /*#__PURE__*/React.createElement(Button, {
        appearance: "ghost",
        accessoryRight: this.renderLeftIcon,
        onPress: this.props.onNavigationLeftPress
      }), /*#__PURE__*/React.createElement(Button, {
        appearance: "ghost",
        accessoryRight: this.renderRightIcon,
        onPress: this.props.onNavigationRightPress
      }));
    });

    _defineProperty(this, "renderTitleElement", props => {
      return /*#__PURE__*/React.createElement(Text, _extends({}, props, {
        style: [props.style, styles.headerButtonText, this.props.titleStyle]
      }), this.props.title);
    });
  }

  render() {
    const _this$props = this.props,
          {
      style,
      titleStyle,
      onTitlePress,
      title,
      lateralNavigationAllowed
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["style", "titleStyle", "onTitlePress", "title", "lateralNavigationAllowed"]);

    return /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [styles.container, style]
    }), /*#__PURE__*/React.createElement(Button, {
      appearance: "ghost",
      accessoryRight: this.renderTitleIcon,
      onPress: onTitlePress
    }, this.renderTitleElement), lateralNavigationAllowed && this.renderLateralNavigationControls());
  }

}
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  headerButtonText: {
    marginHorizontal: 0
  },
  headerButtonIcon: {
    marginHorizontal: 0
  },
  lateralIcon: {
    marginHorizontal: 0
  },
  subContainer: {
    flexDirection: 'row',
    justifyContent: 'center'
  }
});